import { render, staticRenderFns } from "./indexNumber.vue?vue&type=template&id=f84efcfc&scoped=true&"
import script from "./indexNumber.vue?vue&type=script&lang=js&"
export * from "./indexNumber.vue?vue&type=script&lang=js&"
import style0 from "./indexNumber.vue?vue&type=style&index=0&id=f84efcfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84efcfc",
  null
  
)

export default component.exports